import Vue from 'vue'

export default new Vue({
    data () {
        return {
            // count is used as a vuejs key to transition messages properly
            count: 0
        }
    },
    methods: {
        sendMessage (message, type) {
            this.$emit('message-sent', message, type, this.count)
            this.count++
        }
    }

})
